<template>
  <div class="menu-section" :style="{marginBottom: !props.isSupportChatMenu ? '0' : '10px'}">
    <div v-for="(item, index) in menuList" :key="index">
      <div class="menu-card" :style="{margin: !props.isSupportChatMenu ? '25px 5px' : '8px 5px 5px'}" @click="onMenuClick(item.path, index)" v-if="checkMenuShow(index)">
        <div class="menu-left">
          <img :src="item.img" alt="" class="menu-icon" />
          <span class="menu-text">{{ $t(item.name) }}</span>
          <div v-if="item.msg && item.isHaveIcons" class="sub_text">{{'🔴 '+ $t(item.msg) +' 🎁' }}</div>
          <div v-if="item.msg && !item.isHaveIcons" class="sub_text">{{ $t(item.msg) }}</div>
        </div>
        <span class="unreadCount" v-if="item.isSupport && unreadMsgCount>0">{{ unreadMsgCount }}</span>
        <img src="@/assets/profile/arrow_right_white45.png" alt="" class="arrow-icon" />
      </div>
    </div>
  </div>


</template>

<script setup lang="ts">
import { ref, inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user';
import { clickOnMenuThemeFour, MENU_LIST_THEME_FOUR, SUPPORT_CHAT_MENU, clickOnCard } from '@/view/profile/supportScript'
import { useActivityStore } from '@/stores/activity'

interface MenuItem {
  name: string
  img: any
  path: string | null
  msg?: string
  isHaveIcons?: boolean
  isSupport?: boolean
}

const activityStore = useActivityStore()
const router = useRouter()
const contactServiceRef = ref()
const poppingIndex = ref<number | null>(null)
const emits = defineEmits(['logout'])
const openLogoutPopup = inject<() => void>('openLogoutPopup')
const userStore = useUserStore()
const unreadMsgCount = computed(() => userStore.unreadCount)
const isPopping = ref(false)

const menuList = computed<MenuItem[]>(() => {
  if (props.isSupportChatMenu) {
    return SUPPORT_CHAT_MENU
  }
  return MENU_LIST_THEME_FOUR
})

const props = defineProps({
    isSupportChatMenu: {
        type: Boolean,
        default: () => false
    }
})

const handleLogoutClick = () => {
  openLogoutPopup?.()
}

const onMenuClick = (path: string | null, index: number) => {
  if (props.isSupportChatMenu) {
    clickOnCard(router, isPopping, '/sd-message')
    return
  } else {
    clickOnMenuThemeFour(router, poppingIndex, contactServiceRef, handleLogoutClick, path, index)
  }
}

const checkMenuShow = (index: number) => {
  if (index === 2) {
    const isAvailableRedeem = activityStore.activityList.some((obj: any) => obj.name === "redeem_code")
    if (isAvailableRedeem) {
      return true
    } else {
      return false
    }
  }

  return true
}
</script>

<style scoped>
.menu-section {
  /* background-color: #1b151f; */
  /* padding: 15px; */
  border-radius: 10px;
  padding: 2px 10px 3px;
  background: #024a49;
}

.section-title {
  color: #fff;
  font-size: 14px;
  margin-bottom: 12px;
  font-weight: bold;
}

.menu-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px;
  border-radius: 6px;
  margin: 10px 0px;
  transition: all 0.2s;
  cursor: pointer;
}


.menu-left {
  display: flex;
  align-items: center;
  width: 100%;
}

.sub_text {
  font-size: 13px;
  text-align: right;
  width: 100%;
  margin-right: 10px;
  color: #ffffff66;
}

.menu-icon {
  width: 23px;
  height: 23px;
  margin-right: 10px;
  padding: 0 10px;
}

.menu-text {
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
}

.arrow-icon {
  width: 12px;
  opacity: 0.8;
}

.unreadCount {
  color: #fff;
  background: rgb(230, 64, 33);
  border-radius: 22px;
  width: 2rem;
  height: 1.125rem;
  font-size: 13px;
  text-align: center;
  margin: 10px;
  padding: 3px;
  margin-right: 1rem;
}

.pop-animate {
  animation: pop-scale 0.25s ease;
}

@keyframes pop-scale {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.96);
  }

  100% {
    transform: scale(1);
  }
}

@media (max-width:450px) {
  .sub_text {
    font-size: 11px;
  }
}
</style>
